import { apiUrl } from '../config/api'
import '../config/httpInterceptor'

export async function listOffPlatformOrders() {
  const r = await fetch(apiUrl('/api/admin/off-platform-orders'))
  if (!r.ok) throw new Error(`HTTP ${r.status}`)
  return r.json()
}

export async function getOffPlatformOrder(id) {
  const r = await fetch(apiUrl(`/api/admin/off-platform-orders/${id}`))
  if (!r.ok) throw new Error(`HTTP ${r.status}`)
  return r.json()
}

export async function createOffPlatformOrder(payload) {
  const r = await fetch(apiUrl('/api/admin/off-platform-orders'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  const body = await r.json().catch(() => null)
  return { ok: r.ok, status: r.status, body }
}

export async function cancelOffPlatformOrder(id) {
  const r = await fetch(apiUrl(`/api/admin/off-platform-orders/${id}`), { method: 'DELETE' })
  const body = await r.json().catch(() => null)
  return { ok: r.ok, status: r.status, body }
}
